export var ZERO_WIDTH_CHAR = '\u200B';